<template>
    <v-btn-toggle class="ml-2" height="30" :style="`flex-direction:${direction}`">
        <v-btn base-color="grey-lighten-2" size="32" @click="copy(share)">
            <v-icon>mdi-link</v-icon>
        </v-btn>

        <s-facebook :window-features="windowFeatures" :share-options="{ url: share }"
            :use-native-behavior="useNativeBehavior" @popup-close="onClose" @popup-open="onOpen" @popup-block="onBlock"
            @popup-focus="onFocus" style="background-color:#01579b">
            <v-icon color="white" size="32">mdi-facebook</v-icon>
        </s-facebook>

        <s-twitter :window-features="windowFeatures" :share-options="{ url: share }" :use-native-behavior="false"
            @popup-close="onClose" @popup-open="onOpen" @popup-block="onBlock" @popup-focus="onFocus"
            style="background-color:#55acee">
            <v-icon color="white" size="32">mdi-twitter</v-icon>
        </s-twitter>

        <s-pinterest :window-features="windowFeatures" :share-options="{ url: share }"
            :use-native-behavior="useNativeBehavior" @popup-close="onClose" @popup-open="onOpen" @popup-block="onBlock"
            @popup-focus="onFocus" style="background-color:red">
            <v-icon color="white" size="32">mdi-pinterest</v-icon>
        </s-pinterest>
    </v-btn-toggle>
</template>

<script>
import { ref } from 'vue';
import { STwitter, SPinterest, SFacebook } from 'vue-socials';
import { copyToClipboard } from '@/utils/utils.js';

export default {
    components: {
        STwitter,
        SPinterest,
        SFacebook,
    },

    props: {
        share: {
            type: String,
            required: true
        },
        direction: {
            type: String,
            default: 'row'
        }
    },

    setup() {
        const copy = (text) => {
            copyToClipboard(text);
        };

        return {
            copy
        };
    },
};
</script>

<style scoped>
.v-btn-group--density-default.v-btn-group {
    height: unset !important;
}
</style>
